import { render, staticRenderFns } from "./WithdrawWallet.vue?vue&type=template&id=3dfe2acc&scoped=true"
import script from "./WithdrawWallet.vue?vue&type=script&lang=js"
export * from "./WithdrawWallet.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWallet.vue?vue&type=style&index=0&id=3dfe2acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe2acc",
  null
  
)

export default component.exports